import { Flex, forwardRef, Text } from '@chakra-ui/react'
import { useEffect } from 'react'

interface IToggleSwitch {
  enabled: boolean
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>
  enabledLabel?: string
  disabledLabel?: string
  changeHandler?: (enabled: boolean) => void
}

const ToggleSwitch = forwardRef((props: IToggleSwitch, ref) => {
  const {
    enabled,
    setEnabled,
    enabledLabel = 'Yes',
    disabledLabel = 'No',
    changeHandler,
    ...rest
  } = props

  useEffect(() => {
    if (changeHandler) {
      changeHandler(enabled)
    }
  }, [enabled])

  return (
    <Flex
      role='switch'
      width='fit-content'
      onClick={() => setEnabled(!enabled)}
      alignItems='center'
      cursor='pointer'
      userSelect='none'
      ref={ref}
      {...rest}
    >
      <Text
        bgColor={enabled ? 'tertiary.600' : 'white'}
        color={enabled ? 'white' : 'black'}
        paddingY='2'
        paddingX='6'
        border='solid 1px gray'
        borderLeftRadius='xl'
        borderColor='gray.500'
      >
        {enabledLabel}
      </Text>
      <Text
        bgColor={!enabled ? 'tertiary.600' : 'white'}
        color={!enabled ? 'white' : 'black'}
        paddingY='2'
        paddingX='6'
        border='solid 1px gray'
        borderRightRadius='xl'
        borderColor='gray.500'
      >
        {disabledLabel}
      </Text>
    </Flex>
  )
})

export { ToggleSwitch }
